import { Beneficiary } from '@models/clients/clients.details/signatoryRegime';

export class BeneficiaryPanelController {
    public isOpen: boolean = false;
    public isEdit: boolean = false;
    public beneficiary: Beneficiary = {};
    public errorMessage: string = '';
    public dropdownOptions: any = {};
    public onSave: (beneficiary: Beneficiary) => void;
    public onClose: () => void;
    public onDelete: (beneficiary: Beneficiary) => void;

    /** @ngInject */
    constructor() {}

    public $onInit(): void {
        this.resetForm();

    }

    public open(beneficiary?: Beneficiary): void {
        this.isOpen = true;
        this.isEdit = !!beneficiary;
        this.errorMessage = ''; // Clear any previous errors
        
        // Prevent body scroll
        document.body.classList.add('slide-out-panel-open');
        
        if (beneficiary && typeof beneficiary === 'object') {
            this.beneficiary = { ...beneficiary };
            
            // If we have currency/bank IDs but no display names, populate them from dropdown options
            if (this.beneficiary.currency && !this.beneficiary.currencyName && this.dropdownOptions && this.dropdownOptions.currency) {
                const selectedCurrency = this.dropdownOptions.currency.find((currency: any) => currency.id === this.beneficiary.currency);
                if (selectedCurrency) {
                    this.beneficiary.currencyName = selectedCurrency.displayName;
                }
            }
            
            if (this.beneficiary.bank && !this.beneficiary.bankName && this.dropdownOptions && this.dropdownOptions.bank) {
                const selectedBank = this.dropdownOptions.bank.find((bank: any) => bank.id === this.beneficiary.bank);
                if (selectedBank) {
                    this.beneficiary.bankName = selectedBank.displayName;
                }
            }
        } else {
            this.resetForm();
        }
    }

    public close(): void {
        this.isOpen = false;
        this.errorMessage = ''; // Clear errors when closing
        
        // Restore body scroll
        document.body.classList.remove('slide-out-panel-open');
        
        if (this.onClose) {
            this.onClose();
        }
    }

    public save(): void {
        console.log('save', this.beneficiary);
        
        // Clear previous error messages
        this.errorMessage = '';
        
        // Validate required fields
        if (!this.beneficiary || !this.beneficiary.beneficiaryName) {
            this.errorMessage = 'Beneficiary name is required. Please enter a beneficiary name before saving.';
            console.error('Beneficiary name is required');
            return; // Don't save or close the panel
        }

        // Ensure beneficiary is properly initialized
        if (!this.beneficiary) {
            this.beneficiary = {};
        }

        // Populate display names for currency and bank
        const beneficiaryToSave = { ...this.beneficiary };
        
        // Set currency display name
        if (beneficiaryToSave.currency && this.dropdownOptions && this.dropdownOptions.currency) {
            const selectedCurrency = this.dropdownOptions.currency.find((currency: any) => currency.id === beneficiaryToSave.currency);
            if (selectedCurrency) {
                beneficiaryToSave.currencyName = selectedCurrency.displayName;
            }
        }
        
        // Set bank display name
        if (beneficiaryToSave.bank && this.dropdownOptions && this.dropdownOptions.bank) {
            const selectedBank = this.dropdownOptions.bank.find((bank: any) => bank.id === beneficiaryToSave.bank);
            if (selectedBank) {
                beneficiaryToSave.bankName = selectedBank.displayName;
            }
        }

        if (this.onSave) {
            (this.onSave as any)({ beneficiary: beneficiaryToSave });
        }
        
        this.close();
    }

    public delete(): void {
        if (this.beneficiary && this.beneficiary.id) {
            if (this.onDelete) {
                (this.onDelete as any)({ beneficiary: { ...this.beneficiary } });
            }
        }
        this.close();
    }

    private resetForm(): void {
        this.beneficiary = {
            id: undefined,
            externalId: '',
            beneficiaryName: '',
            currency: undefined,
            currencyName: '',
            amount: '',
            addressOfBeneficiary: '',
            accountNumber: '',
            codeIban: '',
            bank: undefined,
            bankName: '',
            bankAddress: '',
            swiftCode: '',
            attention: '',
            reference: ''
        };
    }
}

export const BeneficiaryPanelComponent: angular.IComponentOptions = {
    template: require('./beneficiary-panel.html'),
    controller: BeneficiaryPanelController,
    controllerAs: '$ctrl',
    bindings: {
        dropdownOptions: '<',
        onSave: '&',
        onClose: '&',
        onDelete: '&'
    }
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/recipients/modals/tabs/beneficiary/beneficiary-panel.ts